@if (showAvgDailyMileage) {
<div class="d-flex align-items-center right-align">
  <div class="avg-daily-mileage-number">
    <ng-container>{{ avgDailyMileage | number: "1.0-2" }} </ng-container>
  </div>
  @if (showAvgDailyMileageArrow) {
  <div class="avg-daily-mileage-arrow">
    @if (filterService?.defaultDateRangeSelected) {
    <img
      src="../../../../assets/icons/trending_flat.svg"
      class="trending-arrow-{{ avgDailyMileageArrow }}"
    />
    }
  </div>
  }
</div>
} @else {
<div class="d-flex align-items-center right-align">
  <div class="avg-daily-mileage-number">-</div>
</div>
}
